import React from 'react'

import CardWithLabeledRowsOfButtons from 'pages/Dashboard/cards/shared/CardWithLabeledRowsOfButtons'

import { color } from 'styles/colors'

type Props = {
  criticalAlertCount: number | string
  majorAlertCount: number | string
  minorAlertCount: number | string
  criticalSdaAlertCount: number | string
  sdaMajorAlertCount: number | string
  sdaMinorAlertCount: number | string
  dirtyFilterCount: number | string
  isLoaded: boolean
}

const HehmDeviceStatusAlerts = ({
  criticalAlertCount,
  majorAlertCount,
  minorAlertCount,
  criticalSdaAlertCount,
  sdaMajorAlertCount,
  sdaMinorAlertCount,
  dirtyFilterCount,
  isLoaded
}: Props) => {
  const criticalAlertIcon = {
    text: 'Critical',
    img: '/img/critical_alert.svg',
    imgAlt: 'Critical Alert Icon',
    quantity: criticalAlertCount,
    accentColor: color('healthCritical'),
    apptentiveEventName: 'view_critical_alerts_customers',
    filter: 'critical',
    tooltip: 'Total number of \'critical\' alerts identified on registered or opted-in customers\' systems.'
  }

  const majorAlertIcon = {
    text: 'Major',
    img: '/img/major_alert.svg',
    imgAlt: 'Major Alert Icon',
    quantity: majorAlertCount,
    accentColor: color('healthFair'),
    apptentiveEventName: 'view_major_alerts_customers',
    filter: 'major',
    tooltip: 'Total number of \'major\' alerts identified on registered or opted-in customers\' systems.'
  }

  const minorAlertIcon = {
    text: 'Minor',
    img: '/img/minor_alert.svg',
    imgAlt: 'Minor Alert Icon',
    quantity: minorAlertCount,
    accentColor: color('healthGreat'),
    apptentiveEventName: 'view_minor_alerts_customers',
    filter: 'minor',
    tooltip: 'Total number of \'minor\' alerts identified on registered or opted-in customers\' systems.'
  }

  const criticalSdaAlertIcon = {
    text: 'Critical SDA',
    img: '/img/critical_sda_alert.svg',
    imgAlt: 'Critical SDA Alert Icon',
    quantity: criticalSdaAlertCount || 0,
    accentColor: color('majorSdaAlert'),
    apptentiveEventName: 'view_critical_sda_alerts_customers',
    gaEventName: 'SDA Critical Alerts',
    filter: 'sda_critical',
    tooltip: 'Total number of \'critical\' SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const majorSdaAlertIcon = {
    text: 'Major SDA',
    img: '/img/major_sda_alert.svg',
    imgAlt: 'Major SDA Alert Icon',
    quantity: sdaMajorAlertCount,
    accentColor: color('majorSdaAlert'),
    apptentiveEventName: 'view_sda_major_alerts_customers',
    gaEventName: 'SDA Major Alerts',
    filter: 'sda_major',
    tooltip: 'Total number of \'major\' SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const minorSdaAlertIcon = {
    text: 'Minor SDA',
    img: '/img/minor_sda_alert.svg',
    imgAlt: 'Minor SDA Alert Icon',
    quantity: sdaMinorAlertCount,
    accentColor: color('minorSdaAlert'),
    apptentiveEventName: 'view_sda_minor_alerts_customers',
    gaEventName: 'SDA Minor Alerts',
    filter: 'sda_minor',
    tooltip: 'Total number of \'minor\' SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const dirtyAirFilterIcon = {
    text: 'Dirty Air Filters',
    img: '/img/dirty_air_filter.svg',
    imgAlt: 'HEHM Dirty Air Filter Icon',
    quantity: dirtyFilterCount,
    accentColor: color('editText'),
    apptentiveEventName: 'view_dirty_filter_alerts_customers',
    gaEventName: 'Dirty Air Filter',
    filter: 'dirty_filter',
    tooltip: 'Total number of \'dirty air filter\' alerts (SDA.006.03) identified on registered or opted-in thermostats'
  }

  return (
    <CardWithLabeledRowsOfButtons
      icon={
        <img
          src="/img/hehm-alert-status.svg"
          alt="HEHM Health Icon"
          style={{ marginRight: '15px' }}
        />
      }
      title={HehmDeviceStatusAlerts.cardTitle}
      applyAccentColorToQuantity
      rows={[
        {
          label: 'Alerts',
          buttons: [criticalAlertIcon, majorAlertIcon, minorAlertIcon]
        },
        {
          label: 'SDAs',
          buttons: [criticalSdaAlertIcon, majorSdaAlertIcon, minorSdaAlertIcon, dirtyAirFilterIcon]
        }
      ]}
      isLoaded={isLoaded}
      hehmEnabled
    />
  )
}

HehmDeviceStatusAlerts.cardTitle = 'Alerts'
HehmDeviceStatusAlerts.cardKey = 'thermostat_alerts'

export default HehmDeviceStatusAlerts
